import { RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Feature } from 'app/model/entities/entity-model';
import { ISortModel } from 'app/shared/ag-fns';
import { DbQueryService } from 'app/shared/db-query.service';
import { EntityFinderDialog } from 'app/shared/entity-finder.dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface FeatureFinderParams {
  // only one or the other of the first two - or neither.
  excludedFeatureIds?: number[];
  includedFeatureIds?: number[];
  rowSelection?: RowSelectionOptions; // default is single
}

@Component({
    template: EntityFinderDialog.HTML,
    host: { 'hostID': crypto.randomUUID().toString() },
    standalone: false
})
export class FeatureFinderDialogComponent extends EntityFinderDialog<Feature, FeatureFinderParams> {

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<FeatureFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    Object.assign(this.config, {
      header: `Select Feature`,
      width: '800px',
      height: '530px',
    });
  }

  override async initDatasource() {
    let features = await this.dbQueryService.getFeatures(true);
    if (this.params.excludedFeatureIds) {
      var excludedIds = new Set(this.params.excludedFeatureIds);
      features = features.filter(x => !excludedIds.has(x.id));
    }

    if (this.params.includedFeatureIds) {
      var includedIds = new Set(this.params.includedFeatureIds);
      features = features.filter(x => includedIds.has(x.id));
    }
    return features;
  }
  
  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Name', field: 'name', filter: 'agTextColumnFilter',  },
    ];
    const sortModel = [
      { colId: 'name', sort: 'asc' },
    ] as ISortModel;
    return [colDefs, sortModel] as const;
  }

}
